import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminStockContentTableView from './AdminStockContentTableView';
import AdminStockContentDetailsView from './AdminStockContentDetailsView';

const AdminStockContentViews = () => (
  <Routes>
    <Route element={<AdminStockContentDetailsView />} path="/create" />
    <Route
      element={<AdminStockContentDetailsView duplicate />}
      path="/:pkEcomStockContent/duplicate"
    />
    <Route
      element={<AdminStockContentDetailsView />}
      path="/:pkEcomStockContent/*"
    />
    <Route element={<AdminStockContentTableView />} path="/" />
    <Route element={<Navigate replace to="/admin/stock-content" />} path="*" />
  </Routes>
);

export default AdminStockContentViews;
